import { render, staticRenderFns } from "./CustomeService.vue?vue&type=template&id=71f7071a&"
import script from "./CustomeService.vue?vue&type=script&lang=js&"
export * from "./CustomeService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports